import { createBlueprint as e } from "@made-people/blueprint";
const c = e({
  slots: {
    triggers: "flex gap-3 z-20 bg-white rounded w-full relative p-6 items-center",
    trigger: "after:content after:h-[1px] after:bg-black after:transition-all data-[is-active='false']:after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] data-[is-active='true']:scale-x-100 hover:after:scale-x-100 after:w-full after:block",
    overlay: "bg-black/40 backdrop-blur-md fixed inset-0 left-0 right-0 top-0 bottom-0",
    mainNavigationWrapper: "flex fixed flex-col top-0 gap-6 left-4 right-4 z-10 origin-top",
    activeMenuWrapper: "bg-white w-full rounded p-6 grid-cols-4	gap-x-6 grid",
    // Link Variants
    imageItemLink: "rounded-lg overflow-hidden",
    imageItem: "w-full h-full object-cover",
    menuSection: "flex flex-col gap-4 col-span-1",
    menuSectionLabel: "text-body-sm",
    menuSectionItems: "flex flex-col gap-3",
    menuSectionItem: "text-body-lg data-[featured='true']:text-primary w-fit after:content after:h-[1px] data-[featured='true']:after:bg-primary after:bg-black after:transition-all after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] hover:after:scale-x-100 after:w-full after:block",
    contentWrapper: "bg-white w-full rounded grid grid-cols-4	gap-x-6 p-6",
    contentSection: "col-span-1 flex flex-col gap-3",
    contentSectionItem: "text-body-sm text-black/60 w-fit after:content after:h-[1px] after:bg-black after:transition-all after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] hover:after:scale-x-100 after:w-full after:block"
  },
  variants: {
    // overlay: {
    //   hidden: { overlay: "bg-black/0" },
    //   visible: { overlay: "bg-black/40 backdrop-blur-md" },
    // },
  }
  // defaultVariants: {
  //   overlay: "visible",
  // },
}), s = e({
  slots: {
    triggers: "flex gap-3 z-20 bg-white rounded w-full relative p-6 items-center",
    trigger: "after:content after:h-[1px] after:bg-black after:transition-all data-[is-active='false']:after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] data-[is-active='true']:scale-x-100 hover:after:scale-x-100 after:w-full after:block",
    overlay: "bg-black/40 backdrop-blur-md fixed inset-0 left-0 right-0 top-0 bottom-0",
    mainNavigationWrapper: "flex fixed flex-col top-0 gap-6 left-4 right-4 z-10 origin-top",
    activeMenuWrapper: "bg-white w-full rounded p-6 grid-cols-4	 gap-x-6 grid",
    // Link Variants
    imageItemLink: "rounded-lg overflow-hidden",
    imageItem: "w-full h-full object-cover",
    menuSection: "flex flex-col gap-4 col-span-1",
    menuSectionLabel: "text-body-sm",
    menuSectionItems: "flex flex-col gap-3",
    menuSectionItem: "text-body-lg data-[featured='true']:text-primary w-fit after:content after:h-[1px] data-[featured='true']:after:bg-primary after:bg-black after:transition-all after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] hover:after:scale-x-100 after:w-full after:block",
    contentWrapper: "bg-white w-full rounded grid grid-cols-4	gap-x-6 p-6",
    contentSection: "col-span-1 flex flex-col gap-3",
    contentSectionItem: "text-body-sm text-black/60 w-fit after:content after:h-[1px] after:bg-black after:transition-all after:scale-x-0 after:origin-left after:duration-[0.7s] after:ease-[cubic-bezier(.19,1,.22,1)] hover:after:scale-x-100 after:w-full after:block"
  },
  variants: {
    // overlay: {
    //   hidden: { overlay: "bg-black/0" },
    //   visible: { overlay: "bg-black/40 backdrop-blur-md" },
    // },
  }
  // defaultVariants: {
  //   overlay: "visible",
  // },
}), t = e({
  slots: {
    wrapper: "w-full",
    item: "w-full flex items-center h-11 px-4 box-border text-heading-2xs",
    label: "flex items-center w-full h-full gap-2",
    link: "underline underline-offset-4",
    goToNextLevel: "w-8 h-8 rounded-full bg-neutral-100 flex justify-center items-center shrink-0 p-2.5 box-border [&>svg]:translate-x-px",
    submenu: "h-full",
    scrollContainer: "overflow-y-scroll scroll-smooth scrolling-touch",
    submenuComponent: "px-4 my-4",
    submenuHeading: "block px-4 my-2.5",
    badge: ""
  },
  variants: {}
}), l = e({
  slots: {
    wrapper: "w-[calc(100vw-72px)] max-w-96 h-full bg-white",
    header: "grid grid-cols-6 gap-2 p-4 h-[72px] items-center border-b-2 border-neutral-50",
    title: "block col-start-2 col-span-4 text-center text-heading-2xs",
    backButton: "col-start-1 w-8 h-8 rounded-full bg-neutral-100 flex justify-center items-center p-2.5 box-border [&>svg]:-translate-x-px",
    closeButtonOutside: "w-8 h-8 p-2.5 box-border text-right bg-red-500 absolute -right-11 top-5 flex justify-center items-center rounded-full bg-white shadow-lg",
    closeButtonInside: "col-start-6 justify-self-end w-8 h-8 rounded-full bg-neutral-100 flex justify-center items-center p-2.5 box-border",
    buttonWrapper: "p-4",
    content: "py-2 h-[calc(100vh-72px)]",
    component: "px-2 my-2",
    siteSettingsTrigger: ""
  },
  variants: {}
}), f = {
  main: l,
  menuItem: t.clone()
}, r = e({
  slots: {
    wrapper: "flex gap-10 text-[var(--foreground)] col-start-4 col-end-8",
    deckWrapper: "bg-white text-black absolute top-[72px] group-data-[scrolled=true]:top-[52px] -z-10 left-0 w-full overflow-hidden",
    deckContent: "grid grid-cols-12 gap-x-1 md:px-component-spacing-lg xl:px-component-spacing-2xl",
    deckColumns: "grid grid-cols-subgrid [&>div:first-child]:col-start-1 [&>div]:col-span-2 [&>div:first-child]:col-end-4 [&>div:only-child]:col-start-4 [&>div:only-child]:col-end-6 w-full col-span-6 pt-6 pb-10",
    topLevel: "flex gap-6 xl:gap-10 items-center",
    deckImage: "h-full aspect-landscape w-full object-cover",
    deckImageWrapper: "col-span-6 bg-[#f1f1f1] h-full aspect-landscape w-full"
  },
  variants: {}
}), a = e({
  slots: {
    submenu: "pb-7 break-inside-avoid-column flex flex-col items-start",
    submenuHeading: "text-label-sm uppercase mb-2 tracking-wide",
    item: "text-label-md xl:text-label-lg py-2"
  },
  variants: {}
}), o = e({
  slots: {
    item: "text-label-md"
  },
  variants: {}
}), d = {
  main: r,
  menuItem: o,
  submenu: a
}, n = e({
  slots: {
    wrapper: "w-[calc(100vw-72px)] max-w-96 h-full bg-white",
    header: "grid grid-cols-6 gap-2 p-4 h-[72px] items-center border-b-2 border-neutral-50",
    title: "block col-start-2 col-span-4 text-center text-heading-2xs",
    backButton: "col-start-1 w-8 h-8 rounded-full bg-neutral-100 flex justify-center items-center p-2.5 box-border [&>svg]:-translate-x-px",
    closeButtonOutside: "w-8 h-8 p-2.5 box-border text-right bg-red-500 absolute -right-11 top-5 flex justify-center items-center rounded-full bg-white shadow-lg",
    closeButtonInside: "col-start-6 justify-self-end w-8 h-8 rounded-full bg-neutral-100 flex justify-center items-center p-2.5 box-border",
    buttonWrapper: "col-span-6",
    content: "py-2 h-[calc(100vh-72px)]"
  },
  variants: {}
}), u = {
  main: n,
  menuItem: t
}, p = e({
  slots: {
    wrapper: "relative w-full rounded-md overflow-hidden",
    content: "absolute left-0 top-0 w-full h-full p-4 flex flex-col justify-between items-start",
    heading: "text-heading-lg text-white max-w-[50%]"
  },
  variants: {}
}), g = e({
  slots: {
    wrapper: "relative w-full flex flex-col gap-4 py-2 items-start",
    products: "flex gap-2 flex-wrap",
    product: "shrink-0 grow-0 size-14 relative",
    link: "block",
    image: "block w-full h-full"
  },
  variants: {}
});
export {
  d as deck2Blueprint,
  c as deckStyles,
  p as featuredImageStyling,
  g as featuredProductsStyling,
  n as foldout,
  l as foldout2,
  f as foldout2Styling,
  u as foldoutStyling,
  t as menuItemStyling,
  s as sidebarStyles
};
//# sourceMappingURL=index-blueprint.es.js.map
